module.exports = __webpack_public_path__ + "static/media/overline.fd790e66.svg";